<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="$l('dialog_title_addBrand') || '新增客户品牌'"
      width="1200px"
      visible
      show-close
      :close-on-click-modal="false"
      :before-close="() => close()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :custCode="custCode"
        @checkbox-change="(e) => (checkedRow = e)"
      >
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="addFormVisible = true"
        >
          {{ $l('btn_manuallyAdd') || '手动新增' }}
        </b-button>
      </Main>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-badge :value="checkedCount" class="ml-2">
          <el-button
            type="primary"
            size="small"
            @click="confirm()"
            :disabled="!checkedCount"
          >
            {{ $l('INDEX.btn_confirm') || '确认' }}
          </el-button>
        </el-badge>
      </span>
    </el-dialog>

    <AddForm
      :visible.sync="addFormVisible"
      :custCode="custCode"
      @reload="$emit('reload')"
      @close="close"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import AddForm from '../add-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main, AddForm },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    custCode: { type: String, default: '' },
  },
  data() {
    return { checkedRow: null, addFormVisible: false }
  },
  computed: {
    checkedCount() {
      return this.checkedRow?.length || 0
    },
  },
  methods: {
    async confirm() {
      if (!this.checkedCount) return

      if (this.loadingOpen()) return

      const listBrandCode = this.checkedRow.map((item) => item.brandCode)
      const res = await this.$api
        .masterCustomerBrandAddApi({ listBrandCode, custCode: this.custCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    close() {
      this.addFormVisible = false
      this.checkedRow = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
